import { Fade } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import tableToolRenderer from '../toolRenderers/tableToolRenderer';
import userActionsToolRenderer from '../toolRenderers/userActionsToolRenderer';
import lineageGraphToolRenderer from '../toolRenderers/lineageGraphToolRenderer';
import {
  ToolRendererArgs,
  OnUserInteraction,
  ToolRendererUserSelectedValue,
} from '../types';
import { ToolText } from './toolDisplay';

type ToolRendererEntry = {
  render: (
    toolArgs: ToolRendererArgs,
    onUserInteraction?: OnUserInteraction,
    selectedValue?: ToolRendererUserSelectedValue,
    isActive?: boolean,
    interactionsDisabled?: boolean,
  ) => JSX.Element;
  expandable?: boolean;
};

const rendererMap: Record<string, ToolRendererEntry> = {
  table_display: { render: tableToolRenderer, expandable: true },
  user_actions_display: { render: userActionsToolRenderer },
  lineage_graph_display: { render: lineageGraphToolRenderer, expandable: true },
};

export const hasFEToolRenderer = (toolName?: string): boolean =>
  !!toolName && toolName in rendererMap;

export const isFEToolExpandable = (toolName: string): boolean =>
  rendererMap[toolName]?.expandable === true;

type Props = {
  toolName?: string;
  toolArgs?: ToolRendererArgs;
  onUserInteraction?: OnUserInteraction;
  selectedValue?: ToolRendererUserSelectedValue;
  isActive?: boolean;
  interactionsDisabled?: boolean;
};

const FEToolRenderer = ({
  toolName = '',
  toolArgs = {},
  onUserInteraction,
  selectedValue,
  isActive,
  interactionsDisabled,
}: Props) => (
  <Fade in>
    <div>
      <ErrorBoundary
        resetKeys={[toolName, toolArgs]}
        fallback={<ToolText>Couldn&apos;t render this result.</ToolText>}
      >
        {rendererMap[toolName]?.render(
          toolArgs,
          onUserInteraction,
          selectedValue,
          isActive,
          interactionsDisabled,
        )}
      </ErrorBoundary>
    </div>
  </Fade>
);

export default FEToolRenderer;
